export const PARKWHIZ = 'parkwhiz';
export const BESTPARKING = 'bestparking';
